import { render, staticRenderFns } from "./artistList.vue?vue&type=template&id=2c02c8b1&scoped=true"
import script from "./artistList.vue?vue&type=script&lang=js"
export * from "./artistList.vue?vue&type=script&lang=js"
import style0 from "./artistList.vue?vue&type=style&index=0&id=2c02c8b1&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/mobile/artistList.less?vue&type=style&index=1&id=2c02c8b1&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02c8b1",
  null
  
)

export default component.exports